import { createContext, useContext } from 'react';
import { Paper, PaperProps } from '@mui/material';

const ListPagePaperContext = createContext(false);

export function useListPagePaper() {
  return useContext(ListPagePaperContext);
}

export function ListPagePaper({ children, sx, ...props }: PaperProps) {
  return (
    <ListPagePaperContext.Provider value>
      <Paper
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: {
            xs: 'auto',
            md: 'calc(100dvh - 200px)',
          },
          mt: 3,
          overflow: 'hidden',
          ...sx,
        }}
        {...props}
      >
        {children}
      </Paper>
    </ListPagePaperContext.Provider>
  );
}
